module.exports = __webpack_public_path__ + "static/media/self-esteem.022d5079.svg";